/** Only public, editable enquiry context belongs in URLs or analytics. */
export const LOCAL_CONTACT_STUDIOS = ["Ely / Soham Studio", "Bury St Edmunds Studio", "Not sure yet"] as const;
export const LOCAL_CONTACT_REASONS = ["Lesson choice", "Studio question", "Nervous beginner", "Booking question", "Other"] as const;
export type LocalContactContext = { preferredStudio: string; questionType: string };
type Query = Record<string, string | string[] | undefined>;
const studioAliases: Record<string, (typeof LOCAL_CONTACT_STUDIOS)[number]> = {
  ely: "Ely / Soham Studio", ely_studio: "Ely / Soham Studio", "ely / soham studio": "Ely / Soham Studio",
  bury: "Bury St Edmunds Studio", "bury-st-edmunds": "Bury St Edmunds Studio", bury_st_edmunds: "Bury St Edmunds Studio", bury_st_edmunds_studio: "Bury St Edmunds Studio", "bury st edmunds studio": "Bury St Edmunds Studio",
  undecided: "Not sure yet", either: "Not sure yet", "not sure yet": "Not sure yet",
};
const reasonAliases: Record<string, (typeof LOCAL_CONTACT_REASONS)[number]> = {
  "lesson choice": "Lesson choice", lesson_choice: "Lesson choice", "studio question": "Studio question", studio_question: "Studio question",
  "nervous beginner": "Nervous beginner", nervous_beginner: "Nervous beginner", "booking question": "Booking question", booking_question: "Booking question", other: "Other",
  "local lesson checkout support": "Booking question", "local lesson availability": "Booking question",
};
function allowlistedValue<T extends string>(value: unknown, options: Record<string, T>): T | "" {
  if (typeof value !== "string") return "";
  const key = value.trim().toLowerCase();
  return Object.hasOwn(options, key) ? options[key] : "";
}
export function getLocalContactContext(query: Query = {}): LocalContactContext {
  return { preferredStudio: allowlistedValue(query.studio, studioAliases), questionType: allowlistedValue(query.reason, reasonAliases) };
}
export function getLocalContactAnalytics(preferredStudio: string, questionType: string) {
  const studio = allowlistedValue(preferredStudio, studioAliases);
  const reason = allowlistedValue(questionType, reasonAliases);
  return {
    location: studio === "Ely / Soham Studio" ? "ely" : studio === "Bury St Edmunds Studio" ? "bury-st-edmunds" : "undecided",
    enquiry_reason: reason === "Lesson choice" ? "lesson_choice" : reason === "Studio question" ? "studio_question" : reason === "Nervous beginner" ? "nervous_beginner" : reason === "Booking question" ? "booking_question" : "other",
  };
}
